import React from "react";
import { getMemberDetail, getKYCStatus, getWithdrawalList, getWithdrawalDetail } from '../../../lib/api/api.data';
// import { serviceToEvent } from './../../lib/kyc.status.util';
import { loadingCount, loadingDecrease } from "../../../lib/loading.count";
import { getFEWalletParams } from "../../../../platform.pay.config";


// 是否要在充值页呼出提示详情，待确认
// import EmergencyAnnouncement from '$LIB/utils/page/emergency.announcement.util';

import translate from "./../../../lib/translate/TranslateJs";


/**
 * @class 提款模块
 * @param {function} ApiGet
 * @param {function} ApiPost
 * @param {function} ApiDomain
 * @param {function ({titie, children, hasClose, okBtnTxt, noBtnTxt, okFunction, noFunction}} modalTip 提示信息的方式(需要手动确认)
 * @param {function (string, boolean|string)} toastTip 提示信息的方式(会自动消失)，参数boolean代表正确错误消息，其它参数待拓展
 * @param {funciton} goFinishKYCInfo 呼出或跳转验证身份证、银行流水等信息
 * @param {function} goFinishMemberInfo 呼出或跳转完善会员资料
 * @param {function (phone|email)} goVerifyContact 呼出或跳转验证手机或邮箱
 * @param {funciton} goAddBankInfo 呼出或跳转添加银行卡信息
 * @param {function} openService 开启24小时客服窗口
 * @param {object[not required]} memberInfo 会员信息，不传入则主动从API获取
 * @param {boolean[not required]} isHideInputTip 是否隐藏输入框下方的提示信息，如果隐藏则默认使用传入的modalTip事件执行提示
 * @param {function[not required]} setLoading 呼出或关闭Loading事件，不传入则使用默认Loading
 * @param {function[not required]} pushGtag 事件执行记录方法，不传入则调用全局事件或不执行
 *
 * @export {function logoutClearCache}
 */


// 登出操作清空钱包模块缓存信息
// export function logoutClearCache() {
//     if (isApp()) {
//         // APP清除缓存
//     } else {
//         // 浏览器清除缓存
//     }
// }


export default class Withdrawal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            step: 1,
            currKey: "",
            isLoading: false,
            payMethods: [],
            currAvailableMethods: [], // 支付渠道
            availableCoinTypes: [],
            uniqueAmountStatus: false, // 金额是否必须以“1-9”结尾
            currDepositDetail: {},
            submitDisabled: false,
            memberInfo: {},
        }

        this.defaultKey = "LB";
        this.feWalletParams = getFEWalletParams();

    }

    componentDidMount() {

        // EmergencyAnnouncement("Deposit");

        this.getPayList();
        this.getDepositFrontData();

        typeof this.props.setPayMethodChange === "function" && this.props.setPayMethodChange(this.onChange);

    }

    componentDidUpdate(prevProps, prevState) {
        if (typeof this.props.setCurrKey === "function") {
            if (prevState.currKey !== this.state.currKey) {
                this.props.setCurrKey(this.state.currKey);
            }
            if (prevState.payMethods.length !== this.state.payMethods.length) {
                this.props.setPayMethods(this.state.payMethods);
            }
        }
    }

    getDepositFrontData = () => {
        // [获取会员资料完善情况，获取 CDU(KYC) 验证状态，获取 PII 验证状态]
        loadingCount("withdrawal");
        this.feWalletParams.toastTip.loading(translate("加载中")())
        // , getKYCStatus()
        Promise.all([getMemberDetail()])
            .then((res) => {
                const memberInfoData = res[0];
                // KYCStatus = res[1];

                // let kycInfo = {};

                // KYCStatus && KYCStatus.isSuccess && KYCStatus.lockStatus.some((v) => {
                //     if (v.type === "Withdrawal") {
                //         kycInfo = v;
                //         return true;
                //     }
                // })

                // 允许存款
                const PassWithdrawal = () => {
                    if (typeof this.props.setAnnouncement === "function") {
                        this.props.setAnnouncement(true)
                    }
                    this.setState({
                        memberInfo: memberInfoData,
                        submitDisabled: false
                    });
                }


                if (memberInfoData.isDeposited == 0) {
                    if (this.feWalletParams?.device == 'APP') {
                        this.feWalletParams.appPiwikEvent({
                            path: `withdrawal_reminder_nodeposit_popup`,
                            title: `Withdrawal No Deposit`
                        })
                    } else {
                        this.feWalletParams.webPiwikUrl("withdrawal_reminder_nodeposit_popup","Withdrawal No Deposit")
                    }
                    
                    this.feWalletParams.modalTip.confirm({
                        wrapClassName: 'goDeposit',
                        title: translate("温馨提示")(),
                        children: translate("请在提款前进行存款")(),
                        okBtnTxt: translate("立即存款")(),
                        noBtnTxt: translate("出口")(),//FP5-1689
                        isShowCloseBtn: true,
                        onlyOKBtn: true,
                        buttonNum: 1,
                        imageIcon: 'warm',
                        okFunction: () => {
                            this.feWalletParams.goDeposit();
                        },
                        noFunction: () => {
                            this.feWalletParams.BackClick()
                        },
                    });
                    return
                }

                let { contacts, firstName } = memberInfoData
				const phoneData = contacts.find((v) => v.contactType.toLocaleLowerCase() === "phone")
                let phoneStatus = phoneData && (phoneData.status.toLocaleLowerCase() == "verified") || false
                const emailData = contacts.find((v) => v.contactType.toLocaleLowerCase() === "email")
                let emailStatus = emailData && (emailData.status.toLocaleLowerCase() == "verified") || false
                let PhoneEmailVerification = this.props.PhoneEmailVerification
                const phone = phoneData.contact || ''
                const email = emailData.contact || ''

                if(!phone || !email || !firstName) {
                    //缺少手机或邮箱，去添加
                    this.feWalletParams.modalTip.info({
                        title: translate("温馨提示")(),
                        children: translate("尚无法处理您的提款申请, 提款前请完整填写您的个人信息")(),
                        okBtnTxt: translate("现在填写")(),
                        okFunction: () => {
                            this.feWalletParams.goFinishMemberInfo()
                        }
                    });
                    return
                }

                if (!emailStatus || !phoneStatus) {
                    //otp验证
                    let verify = ''
                    if(!emailStatus && !phoneStatus) {
                        verify = 'All'
                    } else if(!emailStatus) {
                        verify = 'Email'
                    } else {
                        verify = 'Phone'
                    }
                    const otpData = {
                        phone,
                        email,
                        memberInfo: memberInfoData,
                    }
                    this.feWalletParams.webPiwikUrl("withdrawal_verify_reminder_popup", "1st Withdrawal Verification")
                    this.feWalletParams.modalTip.confirm({
                        wrapClassName:"withdrawalOTPModal",
                        title: translate("安全认证")(),
                        children: <PhoneEmailVerification status={{ emailStatus, phoneStatus }}></PhoneEmailVerification>,
                        okBtnTxt: translate("立即验证")(),
                        noBtnTxt: translate("稍候验证")(),
                        closable: true,
                        noFunction: () => {
                            this.feWalletParams.BackClick()
                        },
                        okFunction: () => {
                            this.feWalletParams.goVerifyContact(verify , otpData, () => { this.getDepositFrontData() });
                        }
                    })
                    return
                }



                // if (memberInfoData.isDeposited === 0) {
                //     this.feWalletParams.modalTip.info({
                //         title: translate("温馨提示")(),
                //         children: translate("请在提款前进行存款")(),
                //         okBtnTxt: translate("立即存款")(),
                //         noBtnTxt: translate("继续")(),
                //         closable: true,
                //         noFunction: () => {
                //             this.feWalletParams.BackClick()
                //         },
                //         okFunction: () => {
                //             this.feWalletParams.goDeposit();
                //         }
                //     });
                // } else if (
                //     !memberInfoData.isVerifiedPhone ||
                //     !memberInfoData.isVerifiedPhone[1] ||
                //     // !memberInfoData.identityCard || // 后续确认是否需要验证
                //     !memberInfoData.firstName
                // ) {
                //     this.feWalletParams.modalTip.info({
                //         title: translate("温馨提示")(),
                //         children: translate("尚无法处理您的提款申请, 提款前请完整填写您的个人信息")(),
                //         okBtnTxt: translate("现在填写")(),
                //         okFunction: () => {
                //             this.feWalletParams.goFinishMemberInfo();
                //         }
                //     });
                // } else if (
                //     !memberInfoData.isVerifiedEmail ||
                //     !memberInfoData.isVerifiedEmail[1]
                // ) {
                //     this.feWalletParams.modalTip.confirm({
                //         title: translate("验证邮箱")(),
                //         children: translate("亲爱的会员，您尚未验证您的邮箱地址。请立即验证以获得最新的消息与活动详情。")(),
                //         okBtnTxt: translate("立即验证")(),
                //         noBtnTxt: translate("暂时跳过")(),
                //         okFunction: () => {
                //             this.feWalletParams.goVerifyContact("email");
                //         },
                //         noFunction: () => {
                //             PassWithdrawal();
                //         }
                //     });
                // }
                // // else if (kycInfo.isLock) {
                // //     this.feWalletParams.modalTip.info({
                // //         title: kycInfo.popupTopic,
                // //         children: kycInfo.popupMessage,
                // //         okBtnTxt: !kycInfo.isKycRuleHit ? translate("关闭")() : translate("立即验证")(),
                // //         okFunction: () => {
                // //             kycInfo.isKycRuleHit && this.feWalletParams.goFinishKYCInfo();
                // //         }
                // //     });
                // // }
                // else {
                PassWithdrawal();
                // }

                loadingDecrease("withdrawal") && this.feWalletParams.toastTip.hide()
            })
    }

    getPayList = () => {
        this.feWalletParams.toastTip.loading(translate("加载中")())
        loadingCount("withdrawal");

        getWithdrawalList((data) => {
            this.feWalletParams.toastTip.hide()
            this.props.payListFormat && this.props.payListFormat(data); // 针对特定情况格式化充值方式数据列
            this.setState({ payMethods: Array.isArray(data) ? data : [] }, () => {
                // const payMethod = this.props.getUrlVars()["payMethod"];
                // this.onChange(payMethod || data[0].code);
                this.onChange(data[0].code);
            });
        }, () => {
            this.feWalletParams.toastTip.hide()
            loadingDecrease("withdrawal")
        });
    }

    withdrawalStatusCheck = (type) => {
        console.log("可根据此类型针对判定：" + type);

        if (this.state.submitDisabled) {
            this.getDepositFrontData();
            return undefined;
        }

        return true;
    }

    onChange = (key) => {
        const methods = this.state.payMethods.find((item) => (item.code === key));
        const availableMethods = methods ? methods.availableMethods : [{ methodCode: "DEFAULT" }];
        const availableCode = availableMethods && availableMethods.length ? availableMethods[0].methodCode : "";
        if (this.feWalletParams.device == 'APP') {
            this.feWalletParams.appPiwikEvent({
                category: 'Withdrawal',
                action: `Switch to ${methods.code}`,
                name: `Withdrawal_C_${methods.code}`,
                path: `withdrawal`,
                title: `Withdrawal`
            })
        } else {
            this.feWalletParams.webPiwikEvent(`Withdrawal`, `Switch to ${methods.code}`, `Withdrawal_C_${methods.code}`)
        }
        let coinTypes = [];
        if (methods && methods.availableCoinTypes && methods.availableCoinTypes.coinTypes) {
            methods.availableCoinTypes.coinTypes.forEach((v, i) => {
                coinTypes[i] = {
                    id: i,
                    code: v,
                    name: "Tether-" + v.replace("USDT-", ""),
                    isNew: availableMethods[i]?.isNew,
                    isFast: availableMethods[i]?.isFast,
                    isHot: availableMethods[i]?.isHot
                };
            })
        }

        this.setState({
            currKey: key,
            currDepositDetail: {},
            availableCoinTypes: coinTypes,
            currAvailableMethods: availableMethods,
            uniqueAmountStatus: methods && methods.uniqueAmountStatus
        });
        this.feWalletParams.toastTip.loading(translate("加载中")())

        loadingCount("withdrawal");
        getWithdrawalDetail(key, availableCode, (res) => {
            loadingDecrease("withdrawal") && this.feWalletParams.toastTip.hide()
            // key === "CTC" && !this.props.deviceCache("CTCTip") && this.setState({showCTCTipList: true});
            res && this.setState({ currDepositDetail: res });
        });

        // this.props.pushGtag("Deposit Nav", "Click", `${key}_DepositPage`);
    }

    changeMethod = (key, code) => {
        getWithdrawalDetail(key, code, (res) => {
            loadingDecrease("withdrawal") && this.feWalletParams.toastTip.hide()
            // key === "CTC" && !this.props.deviceCache("CTCTip") && this.setState({showCTCTipList: true});
            res && this.setState({ currDepositDetail: res });
        });
    }

    render() {
        const {
            LoadSpinner,
            MethodButtons,
            PayListDOM,
        } = this.props;

        const params = {
            memberInfo: this.state.memberInfo,
            submitDisabled: this.state.submitDisabled,
            currAvailableMethods: this.state.currAvailableMethods,
            currDepositDetail: this.state.currDepositDetail,
            uniqueAmountStatus: this.state.uniqueAmountStatus,
            availableCoinTypes: this.state.availableCoinTypes,
            onChange: this.onChange,
            changeMethod: this.changeMethod,
            withdrawalStatusCheck: this.withdrawalStatusCheck,
            setStep: (v) => {
                this.setState({ step: v });
                if (v * 1 !== 1) {
                    this.feWalletParams.withdrawalHeader(false)
                } else {
                    this.feWalletParams.withdrawalHeader(true)
                }
            },
            setLoading: (v) => {
                if(v){
                    this.feWalletParams.toastTip.loading(translate("加载中")())
                }else{
                    this.feWalletParams.toastTip.hide()
                }
            },
            setDepositDetail: (v) => { this.setState({ currDepositDetail: v }) }
        }

        return <>
            {
                typeof this.props.setPayMethodChange !== "function" && this.state.payMethods.length && this.state.step === 1 ? <MethodButtons
                    currCode={this.state.currKey}
                    payMethods={this.state.payMethods}
                    onClick={(code) => { this.onChange(code) }}
                /> : null
            }
            {
                PayListDOM(this.state.currKey, params)
            }
        </>
    }
}
